import { Checkbox } from '@zep-us/zus';
import { type AiBuilderChoiceOption } from '../store';
import { AiBuilderChoiceOptionShell } from './AiBuilderChoiceOptionShell';
export const AiBuilderCheckboxOptionButton = ({
  onSelect,
  option,
  selected
}: {
  onSelect: () => void;
  option: AiBuilderChoiceOption;
  selected: boolean;
}) => {
  return <AiBuilderChoiceOptionShell option={option} selected={selected} onSelect={onSelect} indicator={<Checkbox checked={selected} tabIndex={-1} aria-hidden="true" data-ai-choice-indicator="checkbox" className="pointer-events-none" />} data-sentry-element="AiBuilderChoiceOptionShell" data-sentry-component="AiBuilderCheckboxOptionButton" data-sentry-source-file="AiBuilderCheckboxOptionButton.tsx" />;
};